<div class="c__warranty-informations">
  <div class="c__warranty-head">
    @if (data?.title) {
      <sd-title [titleLevel]="data?.titleLevel ? data?.titleLevel : 7" class="c__main-title is-body-s is-bold">
        <sd-html [html]="data?.title" tag="span" />
      </sd-title>
    }
    @if (data?.price) {
      <div class="c__warranty-price">
        <p class="is-bold">{{data?.price}}</p>
      </div>
    }
  </div>

  @if (data?.subtitle) {
    <sd-title [titleLevel]="data?.titleLevel ? data?.titleLevel + 1 : 7" class="c__subtitle is-caption">
      <sd-html [html]="data?.subtitle" tag="span" />
    </sd-title>
  }

  @if (data?.footnote) {
    <div class="c__warranty-footnote">
      <sd-icon name="icon-alert-circle" [size]="IconSizeEnum.xs" />
      <sd-html innerClass="is-overline" [html]="data?.footnote" />
    </div>
  }
</div>
